import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import { RESERVATION_LIST_BY_UPDATED_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_QUERY } from "../schema";

type Props = {
	queryVariables?: {
		hotelID: string;
		from: string;
		to: string;
	};
};

export const useReservationListByUpdatedDateQuery = ({ queryVariables }: Props) => {
	const { data } = useCustomSuspenseQuery(
		RESERVATION_LIST_BY_UPDATED_DATE_FOR_MANAGEMENT_RESERVATION_SEARCH_QUERY,
		queryVariables ? { variables: queryVariables } : undefined,
		queryVariables === undefined, // skipToken = true
	);

	const { queryData } = Converter.useReservationListByUpdatedDateQueryData({ serverData: data });

	return {
		queryData,
	};
};
